import { render, staticRenderFns } from "./extractConfigurationItemDetail.vue?vue&type=template&id=7c8123ae&scoped=true"
import script from "./extractConfigurationItemDetail.vue?vue&type=script&lang=js"
export * from "./extractConfigurationItemDetail.vue?vue&type=script&lang=js"
import style0 from "./extractConfigurationItemDetail.vue?vue&type=style&index=0&id=7c8123ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8123ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8123ae')) {
      api.createRecord('7c8123ae', component.options)
    } else {
      api.reload('7c8123ae', component.options)
    }
    module.hot.accept("./extractConfigurationItemDetail.vue?vue&type=template&id=7c8123ae&scoped=true", function () {
      api.rerender('7c8123ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/extractConfigurationItem/extractConfigurationItemDetail.vue"
export default component.exports